import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/custom404.jsx");
